/** i18n keys under `pageTitle` in assets/i18n — use as route `title` values. */
export const PAGE_TITLE_KEYS = {
  app: 'pageTitle.app',
  overview: 'pageTitle.overview',
  case: 'pageTitle.case',
  dashboard: 'pageTitle.dashboard',
  chat: 'pageTitle.chat',
  drafts: 'pageTitle.drafts',
  documents: 'pageTitle.documents',
  templates: 'pageTitle.templates',
  contentHub: 'pageTitle.contentHub',
  memories: 'pageTitle.memories',
  deubner: 'pageTitle.deubner',
  deubnerTax: 'pageTitle.deubnerTax',
  agents: 'pageTitle.agents',
  skills: 'pageTitle.skills',
  tools: 'pageTitle.tools',
  workflows: 'pageTitle.workflows',
  sysadmin: 'pageTitle.sysadmin',
} as const;
